import apiSlice from '../api/api.slice';
import {
  PointsSummary,
  PointsHistoryRecord,
  RedemptionRecord,
  RedeemResponse,
  PaginatedResponse,
} from './points.types';

const pointsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMyPointsSummary: builder.query<PointsSummary, void>({
      query: () => ({ url: '/api/v1/points/me', method: 'GET' }),
      transformResponse: (response: { status: string } & PointsSummary) => ({
        currentPoints: response.currentPoints,
        tier: response.tier,
        highestTier: response.highestTier,
        nextTierThreshold: response.nextTierThreshold,
        pointsToNextTier: response.pointsToNextTier,
        redemptionEligible: response.redemptionEligible,
      }),
      providesTags: ['Points'],
    }),

    getMyPointsHistory: builder.query<
      PaginatedResponse<PointsHistoryRecord>,
      { page?: number; limit?: number }
    >({
      query: ({ page = 1, limit = 20 } = {}) => ({
        url: `/api/v1/points/me/history?page=${page}&limit=${limit}`,
        method: 'GET',
      }),
      transformResponse: (
        response: { status: string } & PaginatedResponse<PointsHistoryRecord>
      ) => ({
        records: response.records,
        total: response.total,
        page: response.page,
        limit: response.limit,
      }),
      providesTags: ['Points'],
    }),

    acceptRewardsTerms: builder.mutation<void, void>({
      query: () => ({ url: '/api/v1/points/accept-terms', method: 'POST' }),
      invalidatesTags: ['User'],
    }),

    redeemPoints: builder.mutation<RedeemResponse, { amount: number }>({
      query: (body) => ({
        url: '/api/v1/points/redeem',
        method: 'POST',
        body,
      }),
      transformResponse: (response: { status: string } & RedeemResponse) => ({
        couponCode: response.couponCode,
        pointsRedeemed: response.pointsRedeemed,
        expiresAt: response.expiresAt,
      }),
      invalidatesTags: ['Points'],
    }),

    getMyRedemptions: builder.query<
      PaginatedResponse<RedemptionRecord>,
      { page?: number; limit?: number }
    >({
      query: ({ page = 1, limit = 20 } = {}) => ({
        url: `/api/v1/points/redemptions?page=${page}&limit=${limit}`,
        method: 'GET',
      }),
      transformResponse: (
        response: {
          status: string;
        } & PaginatedResponse<RedemptionRecord>
      ) => ({
        records: response.records,
        total: response.total,
        page: response.page,
        limit: response.limit,
      }),
      providesTags: ['Points'],
    }),
  }),
});

export const {
  useGetMyPointsSummaryQuery,
  useGetMyPointsHistoryQuery,
  useRedeemPointsMutation,
  useGetMyRedemptionsQuery,
  useAcceptRewardsTermsMutation,
} = pointsApiSlice;
